<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="mx-auto flex w-full flex-wrap p-4">
        <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
            <div>
                <div class="flex items-center gap-1">
                    <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                        <button mat-icon-button color="primary">
                        <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        </button>
                    </div>

                    <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                        <div class="p-4">
                        <p>Equipos o materiales que dejas en un cliente o ruta. 
                            Registra qué activo está en qué lugar/persona (ej.: 
                            enfriadores, exhibidores) y su estado. Úsalo para asignar,
                            retirar o cambiar responsable y llevar control por serie.
                        </p>
                        </div>
                    </mat-menu>
                    <h2 class="text-xl font-semibold leading-8 tracking-tight">
                        Activos Asignados
                    </h2>
                </div>
                
                <div class="text-sm text-secondary font-medium tracking-tight">
                    Lista, procesa y asigna los <b>activos</b> a los <b>socios de negocio</b>.
                </div>
            </div>
            <!-- Header -->
            <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex shrink-0">
                    <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]"
                        [typeFilter]="'master'" (selectionFilterApply)="getList()">
                    </app-status-filters>
                    <!-- Title -->
                    <!--<div class="text-3xl font-extrabold tracking-tight">Tipos de Vehiculo</div> -->
                </div>
                <!-- Actions -->
                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                    <button mat-icon-button color="primary" (click)="openModal()" matTooltip="Nuevo Registro">
                        <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div
            class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
            <!-- Main Content (Table and Paginator) -->
            <div class="pt-1 mx-6">
                <!-- Tabla -->
                <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
                    <!-- Header -->
                    <div class="overflow-auto flex-1 dark:bg-gray-900">
                        <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
                            (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>

                            <ng-container matColumnDef="asset">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Activo</th>
                                <td mat-cell *matCellDef="let element" class="text-sm uppercase leading-tight">
                                    <b class="f-10">{{ element?.asset?.code }}</b><br>
                                    {{element?.asset?.name}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="distributionChain">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Cadena de
                                    Distribución</th>
                                <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
                                    <div *ngIf="getCode(element?.distributionChain) as code">
                                        <b class="f-10">{{ code }}</b>
                                    </div>
                                    {{element?.distributionChain?.name}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="salesOffice">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Oficina</th>
                                <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
                                    <div *ngIf="getCode(element?.salesOffice) as code">
                                        <b class="f-10">{{ code }}</b>
                                    </div>
                                    {{element?.salesOffice?.name}}
                            </ng-container>

                            <!--<ng-container matColumnDef="routes">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Territorios</th>
                    <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
                        <div class="text-content">
                            <span class="font-descrip"> {{element?.routes?.name}}</span>
                        </div>
                    </td>
                </ng-container>-->

                            <ng-container matColumnDef="subRoute">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Ruta</th>
                                <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
                                    {{element?.subRoute?.name}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="shipTo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Solicitante
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
                                    <div class="text-content">
                                        <span class="font-descrip"> {{element?.shipTo?.name}}</span>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="assignmentStartDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha de inicio</th>
                                <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                                    {{ formatDate(element?.assignmentStartDate)}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="assignmentEndDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha de fin</th>
                                <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                                    {{ formatDate(element?.assignmentEndDate)}}
                                </td>
                            </ng-container>

                            <!--<ng-container matColumnDef="user">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Usuario</th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left uppercase">
                        {{ element?.user?.user_login?.username}}
                    </td>
                </ng-container>-->

                            <ng-container matColumnDef="document">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Documento</th>
                                <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                                    {{ element?.document}}
                                </td>
                            </ng-container>

                            <!-- Estado -->
                            <ng-container matColumnDef="statusId">
                                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
                                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                    <mat-slide-toggle class="custom-slide-toggle primary"
                                        [checked]="element.statusId == 1" [(ngModel)]="element.statusId"
                                        [color]="'success'" (ngModelChange)="onStatusChange($event, element)">
                                    </mat-slide-toggle>
                                </td>
                            </ng-container>

                            <!-- Acciones -->
                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                                <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                                    <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #actionMenu="matMenu">
                                        <button mat-menu-item (click)="openModal(element)">
                                            <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                            <span>Editar Registro</span>
                                        </button>
                                        <button mat-menu-item (click)="openDeleteDialog(element)">
                                            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                            <span>Eliminar Registro</span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </ng-container>

                            <!-- Header Row -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"
                                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

                            <!-- Fila principal -->
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
                        </table>
                    </div>
                    <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo
                        sentimos, no hay registros para mostrar.
                    </div>
                </div>

                <!-- Paginación debería asignar valor a this.pageSize-->
                <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
                    <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
                        [length]="totalItems" [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
                </div>
            </div>
        </div>

        <!-- Modal Agregar y Editar -->
        <ng-template #actionModal>
            <h2 mat-dialog-title class="text-lg font-bold mb-1">{{ (this.id == null ? 'Nuevo' : 'Editar')}} Registro
            </h2>
            <mat-dialog-content class="modal-content">
                <mat-tab-group>
                    <mat-tab label="Datos Generales">
                        <form #modalForm="ngForm">
                            <div class="grid grid-cols-2 gap-y-2 gap-x-4">

                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Activo</mat-label>
                                    <mat-select [(ngModel)]="currentAssetControl.asset" name="asset"
                                        (selectionChange)="onSelectionChange()" placeholder="Seleccione un Asset">
                                        @for (asset of listAsset; track asset) {
                                        <mat-option [value]="asset._id">
                                            {{ asset?.code }} - {{ asset?.name }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Cadena de Distribución</mat-label>
                                    <mat-select [(ngModel)]="currentAssetControl.distributionChain"
                                        name="distributionChain" (selectionChange)="fetchShipTo()"
                                        placeholder="Seleccione una cadena de distribución">
                                        @for (type of listDistributionChain; track type) {
                                        <mat-option [value]="type._id">
                                            {{ type.name }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label class="block text-gray-700">Oficina de Venta</mat-label>
                                    <mat-select [(ngModel)]="currentAssetControl.salesOffice" name="salesOffice"
                                        (selectionChange)="getAllSubRouteList(currentAssetControl.salesOffice)">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchOffice"
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="changueOptionsSalesOffice($event)"
                                                placeholderLabel="Buscar oficina..."
                                                noEntriesFoundLabel="No se encontraron resultados">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @for (office of listFilterSalesOfficeList(); track office) {
                                        <mat-option [value]="office._id">
                                            <b *ngIf="getCode(office) as code">{{ code }} - </b>{{ office.name }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="fill" class="modal-input w-full">
                                    <mat-label>Territorio</mat-label>
                                    <mat-select [(ngModel)]="currentAssetControl.routes" name="routes" multiple>
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchRoute"
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="changueOptionsRoute($event)"
                                                placeholderLabel="Buscar Territorio..."
                                                noEntriesFoundLabel="No se encontraron resultados">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @for (route of listFilterRouteList(); track route) {
                                        <mat-option [value]="route._id">
                                            {{ route.name }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="fill" class="modal-input w-full">
                                    <mat-label>Ruta</mat-label>
                                    <mat-select [(ngModel)]="currentAssetControl.subRoute" name="subRoute"
                                        (selectionChange)="fetchShipTo()">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchSubRoute"
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="changueOptionsSubRoute($event)"
                                                placeholderLabel="Buscar Ruta..."
                                                noEntriesFoundLabel="No se encontraron resultados">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @for (subRoute of listFilterSubRouteList(); track subRoute) {
                                        <mat-option [value]="subRoute._id">
                                            {{ subRoute.name }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="w-full">
                                    <mat-label>Solicitante</mat-label>
                                    <input type="text" placeholder="Selecciona solicitante"
                                        aria-label="Selecciona solicitante" matInput [formControl]="shipToControl"
                                        [matAutocomplete]="autoShipTo">
                                    <mat-autocomplete #autoShipTo="matAutocomplete" [displayWith]="fetchShipToName"
                                        (optionSelected)="onShipToChange()">
                                        @for (shipTo of shipToList; track shipTo) {
                                        <mat-option [value]="shipTo._id" class="text-content">
                                            {{shipTo?.externalKeys?.code + ' - '}}{{ shipTo.name }}
                                        </mat-option>
                                        }
                                    </mat-autocomplete>
                                </mat-form-field>

                                <mat-form-field class="w-full">
                                    <mat-label>Fecha de Inicio</mat-label>
                                    <input matInput [matDatepicker]="dateDe"
                                        [(ngModel)]="currentAssetControl.assignmentStartDate" name="assignmentStartDate"
                                        required>
                                    <mat-datepicker-toggle matIconSuffix [for]="dateDe"></mat-datepicker-toggle>
                                    <mat-datepicker #dateDe></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field class="w-full">
                                    <mat-label>Fecha de Fin</mat-label>
                                    <input matInput [matDatepicker]="dateEn"
                                        [(ngModel)]="currentAssetControl.assignmentEndDate" name="assignmentEndDate"
                                        required>
                                    <mat-datepicker-toggle matIconSuffix [for]="dateEn"></mat-datepicker-toggle>
                                    <mat-datepicker #dateEn></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <mat-form-field appearance="fill" class="w-full">
                                <mat-label>Documento</mat-label>
                                <input matInput [(ngModel)]="currentAssetControl.document" name="name"
                                    oninput="this.value = this.value.toUpperCase()" required>
                            </mat-form-field>
                            <div class="grid grid-cols-2 gap-y-2 gap-x-4">

                                <div class="w-full flex items-center">
                                    <mat-slide-toggle class="custom-slide-toggle primary"
                                        [(ngModel)]="currentAssetControl.type" name="type" [color]="'success'"
                                        (ngModelChange)="onTypeChange($event, currentAssetControl)">
                                    </mat-slide-toggle>
                                    {{currentAssetControl.type == '1' ? 'Con comentario' : 'Sin comentario'}}
                                </div>

                                <mat-form-field class="w-full">
                                    <mat-label>Comentario</mat-label>
                                    <input matInput [(ngModel)]="currentAssetControl.comment" name="comment" required
                                        [disabled]="currentAssetControl.type != 1">
                                </mat-form-field>

                                <mat-form-field class="w-full">
                                    <mat-label>Tipo</mat-label>
                                    <mat-select [(ngModel)]="currentAssetControl.buttonType" name="buttonType" required>
                                        @for (buttonType of listButtonType; track buttonType) {
                                        <mat-option [value]="buttonType.code">
                                            {{ buttonType.name }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="w-full">
                                    <mat-label>Color del boton</mat-label>
                                    <input matInput [(colorPicker)]="currentAssetControl.buttonColor"
                                        [cpPosition]="'top'" [style.background]="currentAssetControl.buttonColor"
                                        [value]="currentAssetControl.buttonColor" name="buttonColor" required />
                                </mat-form-field>

                                <mat-form-field class="w-full">
                                    <mat-label>Color del texto</mat-label>
                                    <input matInput [(colorPicker)]="currentAssetControl.buttonTextColor"
                                        [cpPosition]="'top'" [style.background]="currentAssetControl.buttonTextColor"
                                        [value]="currentAssetControl.buttonTextColor" name="buttonTextColor" required />
                                </mat-form-field>



                            </div>
                        </form>
                    </mat-tab>

                    <mat-tab label="Incidencias">

                    </mat-tab>
                </mat-tab-group>

            </mat-dialog-content>
            <mat-dialog-actions class="modal-actions flex justify-end">
                <button mat-button mat-dialog-close class="align-left">Cancelar</button>
                <button mat-raised-button color="primary" (click)="onSubmit()"
                    [disabled]="!modalForm.valid">Guardar</button>
            </mat-dialog-actions>
        </ng-template>

        <ng-template #deleteDialog let-data>
            <div class="flex items-start space-x-2 mb-4">
                <div class="flex items-center">
                    <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
                        style="font-size: 32px;"></mat-icon>
                </div>
                <div class="grid">
                    <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
                    <mat-dialog-content class="modal-content mt-0">
                        <p>¿Está seguro que desea eliminar el registro?</p>
                    </mat-dialog-content>
                </div>
            </div>
            <mat-dialog-actions class="modal-actions flex justify-end">
                <button mat-button mat-dialog-close class="align-left">Conservar</button>
                <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
            </mat-dialog-actions>
        </ng-template>
    </div>
    <!-- Filtros -->
    <app-filter (onFilterEvent)="getList()" (onCleanEvent)="clearFilters()" (onPanelOpened)="onFilterPanelOpened()">
        <app-dates-filters [form]="form" [showDateCreationRange]="true" [loadData]="loadFiltersData"></app-dates-filters>
        <app-configuration-filters [form]="form"
        [distributionChain]="true"
        [salesOffice]="true"
        [loadData]="loadFiltersData"
        ></app-configuration-filters>
    </app-filter>
</mat-sidenav-container>